import React, { useEffect, useState } from 'react'
import Layout from '../../../brands/components/Layout'
import { Formik } from 'formik'
import { InputField } from '../../../../components'
import TextAreaField from '../../../../components/Form/TextArea'
import './index.css'
import SelectField from '../../../../components/Form/Select'
// import { Icon } from '@iconify/react'
// import { Profile } from '../../../../assets/images'
import { useNavigate } from 'react-router-dom'
import { getLocations } from '../../../userslisting/createuser/api'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { createAnnouncementSchema } from '../schema'
import { sendAnnouncement } from '../../api'
import { getLookupValues } from '../../../userslisting/createuser/api'
import { Announcement } from '../../types'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { MAX_CHAR_COUNT } from '../../../../utils/index'
const PostAnnouncement: React.FC = () => {
    // const items = Array.from({ length: 9 })
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [locations, setLocations] = useState<
        { label: string; value: string }[]
    >([])
    const [whoCanView, setWhoCanView] = useState<
        { label: string; value: string; id: number }[]
    >([])

    const lookups = async () => {
        try {
            const lookupValues = await getLookupValues()
            const resourceTypeData = lookupValues?.data?.filter(
                (item: any) => item.lookUpType === 'AnnouncementType'
            )
            // Transform filtered results into label and value format for ResourceType
            const transformedFreqTypeData = resourceTypeData.map(
                (item: any) => ({
                    label: item.lookUpValue,
                    value: item.lookUpValue,
                    id: item.id,
                })
            )
            setWhoCanView(transformedFreqTypeData)
            // dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }
    const getLocationData = async () => {
        try {
            const response = await getLocations()
            const transformedLocations = response?.data?.data?.map(
                (location: any) => ({
                    value: location.id,
                    label: location.name,
                })
            )
            setLocations(transformedLocations)
            dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }

    useEffect(() => {
        dispatch(SHOW_LOADER())
        lookups()
        getLocationData()
    }, [])

    const handleSubmit = async (values: any) => {
        dispatch(SHOW_LOADER())
        try {
            const payload: Announcement = {
                title: values.title, // Required
                description: values.description, //Required
                metaData: null, // always null
                locationId: values.location, // required
                lookUpId: values.canView, // AnnouncementTypeId
                usersId: null,
            }
            if (values.link) payload.link = values.link
            const res = await sendAnnouncement(payload)
            if (res) {
                dispatch(
                    SHOW_NOTIFICATION({
                        type: 'success',
                        message: 'Announcement sent successfully',
                    })
                )
                navigate('/announcements')
            }
            dispatch(HIDE_LOADER())
        } catch (err) {
            SHOW_NOTIFICATION({
                type: 'error',
                message: 'Failed to send announcement',
            })
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }

    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Post Announcement</h4>
                    </div>
                    <div className="upload-form">
                        <Formik
                            initialValues={{
                                title: '',
                                location: '',
                                canView: 1,
                                link: '',
                                description: '',
                            }}
                            validationSchema={createAnnouncementSchema}
                            onSubmit={handleSubmit}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="text"
                                                lable={'Title'}
                                                name="title"
                                                value={values.title}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.title}
                                                touched={touched.title}
                                                defaultValue={'Post Title'}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <SelectField
                                                name="location"
                                                label="By Location"
                                                options={[
                                                    {
                                                        value: '',
                                                        label: 'Select',
                                                    },
                                                    ...locations,
                                                ]}
                                                value={values.location}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.location}
                                                touched={touched.location}
                                                defaultValue="Select"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6 view-block">
                                            <label className="pt-2">
                                                Who can view
                                            </label>
                                            {whoCanView.map((item) => (
                                                <li key={item.id}>
                                                    <input
                                                        type="radio"
                                                        id={item.value}
                                                        name="canView"
                                                        value={item.id}
                                                        checked={
                                                            values.canView ===
                                                            item.id
                                                        }
                                                        onChange={(e) => {
                                                            setFieldValue(
                                                                'canView',
                                                                parseInt(
                                                                    e.target
                                                                        .value
                                                                )
                                                            )
                                                        }}
                                                    />
                                                    <label htmlFor={item.value}>
                                                        {item.label}
                                                    </label>
                                                </li>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="text"
                                                lable={'Link (Optional)'}
                                                name="link"
                                                value={values.link}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.link}
                                                touched={touched.link}
                                                // defaultValue={'Post Title'}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <TextAreaField
                                                name="description"
                                                label="Description"
                                                placeholder=""
                                                value={values.description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.description}
                                                touched={touched.description}
                                                defaultValue=""
                                                rows={6}
                                                maxLength={MAX_CHAR_COUNT}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4 mb-4">
                                        <div className="col-sm-6 button-block">
                                            <a
                                                className="button button-primary me-5"
                                                type="submit"
                                                onClick={() => handleSubmit()}
                                            >
                                                POST
                                            </a>
                                            <a
                                                className="button button-outline"
                                                onClick={() =>
                                                    navigate('/announcements')
                                                }
                                            >
                                                CANCEL
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default PostAnnouncement
